// extracted by mini-css-extract-plugin
export default {"section":"Works_section__u1yZY"};